import { createMuiTheme } from '@material-ui/core/styles';
import {green, grey} from '@material-ui/core/colors';

export default createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      light: '#DD85A5',
      main: '#D74177',
      dark: '#A3315B',
      contrastText: '#fff',
    },
    secondary: {
      light: '#FFF8D6',
      main: '#FFE98A',
      dark: '#CCBB6E',
      contrastText: '#fff',
    },
    background: {
      default: grey[50]
    },
    text: {
      primary: grey[900]
    }
  },
});

//D74177
//FFE98A